import React from 'react';
import { useTranslate } from './TranslationText';
import { OperatingSystems } from './Layout';
import './CustomCss/header.css';

const appleStoreLink = process.env.REACT_APP_APPLE_LINK;
const playStoreLink = process.env.REACT_APP_PLAY_LINK;
const baseURL = process.env.REACT_APP_BASE_URL2;

const AppBanner = ({ agentOS }) => {
    const { translate } = useTranslate();

    if (agentOS !== OperatingSystems.IOS && agentOS !== OperatingSystems.ANDROID) {
        return null;
    }

    const storeLink = agentOS === OperatingSystems.ANDROID ? playStoreLink : appleStoreLink;
    
    // Deep link logic similar to OpenApp.js
    const deepLink = `intent://success#Intent;scheme=myappscheme;package=com.eahs.main;S.browser_fallback_url=${encodeURIComponent(storeLink)};end;`;
    
    // For iOS, intent scheme doesn't work the same way, we usually use custom protocol or universal links
    // But since the user pointed to OpenApp.js, I will use a similar approach or direct store link if on iOS
    const finalLink = agentOS === OperatingSystems.IOS ? storeLink : deepLink;

    return (
        <div className="smart-app-banner">
            <div className="banner-content container">
                <div className="d-flex align-items-center w-100">
                    <div className="app-icon-container mx-2">
                        <img src={`${baseURL}/assets/img/squarlogo.png`} alt="App Icon" className="app-icon" />
                    </div>
                    
                    <div className="app-info flex-grow-1">
                        <h6 className="app-title mb-0">
                            {translate('web.appTitle', 'EAHS - Open EAHS app')}
                        </h6>
                        {/* <p className="app-subtitle mb-0 text-muted">
                            {translate('web.appSubtitle', 'Open in the EAHS app')}
                        </p> */}
                    </div>
                    
                    <a href={finalLink} target="_top" rel="noopener noreferrer" className="btn btn-primary open-app-btn rounded-pill px-3">
                        {translate('web.open', 'OPEN')}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default AppBanner;
